// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1pGW1","info":"PatientInfo_info___0QOD"};